import React from 'react'
import "./FAQ.css"
import FAQ_Accordian from './FAQ_Accordian/FAQ_Accordian'
import Common_title from '../common-title/Common_title'

function FAQ() {
    return (
        <>
            <section className='FAQ margin_section'>
                <div className="container">
                    <Common_title headingText="FAQ " />
                    <div className="faq_section_holder">

                        <div className="row ">
                            <div className="col-md-5 col-sm-6">
                                <div className="img_section_holder">
                                    <div className="img_holder">
                                        <img src="/assets/images/faq/mobiles.png" alt="FAQ" className='FAQ_img' />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-7 col-sm-6">
                                <FAQ_Accordian />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FAQ